import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import moment from "moment";
import Calendar from "react-calendar";
import "./TherapistRegisterData.css";
import Select from "../../components/select/Select";
import { checkParams } from "../../../src/util/Util";
import { useParams } from "react-router-dom";

const TherapistRegisterData = ({ setPtRegStep, props }) => {
  let { code } = useParams();
  const [therapistData, setTherapistData] = useState({});
  const [stateSelected, setStateSelected] = useState("");
  const [canadaStateList, setCanadaStateList] = useState([]);
  const [unitedStateStateList, setUnitedStateStateList] = useState([]);
  const [stateSelectedError, setStateSelectedError] = useState("");
  const [countrySelected, setCountrySelected] = useState("United States");
  const [isAllFilled, setAllFilled] = useState(false);
  const [licencedObj, setLicencedObj] = useState([{ state: "", licence_date: "" }]);
  const [caliHeight, setCaliHeight] = useState(0);
  const [caliLeft, setCaliLeft] = useState(0);
  const [caliDate, setCaliDate] = useState(new Date());
  const [dateIsUpdated, setDateIsUpdated] = useState(false);
  const [caliTarget, setCaliTarget] = useState(-1);
  const [openCalendar, setOpenCalendar] = useState(false);
  const wrapperRef = useRef("");

  useEffect(() => {
    var timeUpdate = setInterval(() => {
      if (!dateIsUpdated) {
        setCaliDate(new Date());
      }
    }, 1000);

    return () => clearInterval(timeUpdate);
  });

  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [npiNumber, setNpiNumber] = useState("");

  const [errorFirstName, setErrorFirstName] = useState("");
  const [errorLastName] = useState("");
  const [errorPhone, setErrorPhone] = useState("");
  const [errorAddress, setErrorAddress] = useState("");
  const [errorCity, setErrorCity] = useState("");
  const [zipCodeError, setZipCodeError] = useState("");
  const [errorLicenceState, setErrorLicenceState] = useState("");
  const [errorLicenceDate, setErrorLicenceDate] = useState("");
  const [npiError, setNpiError] = useState("");
  const [countryList] = useState([{ value: "United States" }, { value: "Canada" }]);

  const handlePhone = (subjectString) => {
    var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    setErrorPhone("");

    if (phoneRegex.test(subjectString)) {
      var formattedPhoneNumber = subjectString.replace(phoneRegex, "($1) $2-$3");
      setPhone(formattedPhoneNumber);
    } else {
      setErrorPhone("Please enter a valid US mobile number.");
      setPhone(subjectString);
    }
  };

  const handleAddress = (value) => {
    setAddress(value);
    if (!checkParams(value, "address")) {
      setErrorAddress("Please enter a valid address.");
    } else {
      setErrorAddress("");
    }
  };

  const handleAddress2 = (value) => {
    setAddress2(value);
  };

  const handleCity = (value) => {
    setCity(value);
    if (!checkParams(value, "city")) {
      setErrorCity("Please enter a valid city.");
    } else {
      setErrorCity("");
    }
  };

  const handleZipCode = (value) => {
    setZipCode(value);
    if (countrySelected === "United States") {
      if (!checkParams(value, "zipcode")) {
        setZipCodeError("Please enter a valid US postal code.");
      } else {
        setZipCodeError("");
      }
    } else {
      if (!checkParams(value, "ca_zip")) {
        setZipCodeError("Please enter a valid Canada postal code.");
      } else {
        setZipCodeError("");
      }
    }
  };

  const handleNpi = (value) => {
    setNpiNumber(value);
    if (isNaN(value) || value.length !== 10) {
      setNpiError("Please enter a valid 10-digit NPI Number");
    } else {
      setNpiError("");
    }
  };

  function useOutsideCalenderAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpenCalendar(false);
          setDateIsUpdated(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideCalenderAlerter(wrapperRef);
  useEffect(() => {
    if (JSON.parse(localStorage.getItem("new_pt_reg_data")) !== null) {
      var pt_reg_data = JSON.parse(localStorage.getItem("new_pt_reg_data"));
      setTherapistData(pt_reg_data);
      var setAsNewUser = { first_name: pt_reg_data.first_name, last_name: pt_reg_data.last_name, is_new_user: 1 };
      localStorage.setItem("userData", JSON.stringify(setAsNewUser));
    }
  }, []);

  useEffect(() => {
    axios
      .post(window.ajaxLink + "cloud_therapist/getStateList", {})
      .then((res) => {
        if (res.data.responseData) {
          var unitedStates = [];
          var canada = [];

          for (var country of res.data.responseData) {
            if (country.country === "United States") {
              unitedStates.push(country);
            } else {
              canada.push(country);
            }
          }

          setCanadaStateList(canada);
          setUnitedStateStateList(unitedStates);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleStateSelected = (callVal, value) => {
    if (callVal && value) {
      callVal(value);
      setStateSelectedError("");
    } else {
      setStateSelectedError("Please select a state from the list.");
    }
  };

  const addNewLicence = () => {
    if (licencedObj.length < 50) {
      var prevLicences = [...licencedObj];
      prevLicences.push({ state: "", licence_date: "" });
      setLicencedObj(prevLicences);
    }
  };

  const deleteLicence = (item) => {
    var prevLicences = [...licencedObj];
    prevLicences.splice(item, 1);
    setLicencedObj(prevLicences);
    checkLicenceValid(licencedObj, "licence_date", setErrorLicenceDate, "");
    checkLicenceValid(prevLicences, "state", setErrorLicenceState, "");
  };

  const handleLicenceState = (item, value) => {
    var prevLicences = [...licencedObj];
    for (var licence of prevLicences) {
      if (licence.state === value) {
        prevLicences[item].state = "";
        setLicencedObj(prevLicences);
        setErrorLicenceState("Please select a state.");
        return;
      }
    }

    prevLicences[item].state = value;
    setLicencedObj(prevLicences);
    checkLicenceValid(prevLicences, "state", setErrorLicenceState, "Please select a state.");
  };

  const handleLicenceDate = (value) => {
    var prevLicences = [...licencedObj];
    prevLicences[caliTarget].licence_date = moment(value).format("l");
    setLicencedObj(prevLicences);
    setCaliDate(new Date(value));
    setDateIsUpdated(true);
    checkLicenceValid(prevLicences, "licence_date", setErrorLicenceDate, "Please select a date.");
  };

  const openCloseLicenceDate = (item, event) => {
    setCaliTarget(item);
    if (licencedObj[item] && licencedObj[item].licence_date) {
      setCaliDate(new Date(licencedObj[item].licence_date));
      setDateIsUpdated(true);
    }

    if (!openCalendar) {
      setOpenCalendar(true);
    }

    if (item === "close") {
      setCaliHeight(0);
      setCaliLeft(0);
      setDateIsUpdated(false);
    } else {
      //setCaliHeight(event.clientY - 80 - event.nativeEvent.layerY);
      setCaliHeight(event.pageY - 342 - event.nativeEvent.layerY);
      setCaliLeft(100);
      //setCaliLeft(event.target.offsetLeft + 91 - event.nativeEvent.layerX);
    }
  };

  const checkLicenceValid = (licObj, mod, licFunc, licText) => {
    var missingParam = false;
    for (var licenceChk of licObj) {
      if (!licenceChk[mod]) {
        missingParam = true;
      }
    }

    if (missingParam) {
      licFunc(licText);
    } else {
      licFunc("");
    }
    return !missingParam;
  };

  const checkValidity = () => {
    handlePhone(phone);
    handleStateSelected(setStateSelected, stateSelected);
    handleAddress(address);
    handleCity(city);
    handleZipCode(zipCode);
    handleNpi(npiNumber);
    checkLicenceValid(licencedObj, "state", setErrorLicenceState, "Please select a state.");
    checkLicenceValid(licencedObj, "licence_date", setErrorLicenceDate, "Please select a date.");

    if (!therapistData.first_name || !therapistData.last_name || !therapistData.email) {
      setErrorFirstName("Your autocomplete data is missing. Please reload the page and start again.");
    }

    if (isAllFilled) {
      axios
        .post(window.ajaxLink + "cloud_therapist/register-therapist", {
          first_name: therapistData.first_name.trim(),
          last_name: therapistData.last_name.trim(),
          email: therapistData.email.trim().toLowerCase(),
          address: address,
          address2: address2,
          phone: phone,
          country: countrySelected,
          state: stateSelected,
          city: city.trim(),
          zip_code: zipCode,
          licences: licencedObj,
          password: therapistData.password.trim(),
          npi_number: npiNumber,
          company_id: localStorage.getItem("company_id") ? localStorage.getItem("company_id") : 0,
          business_id: therapistData.business_id,
          newMemberRegister: true,
          invitationCode: code,
        })
        .then((res) => {
          if (res.data.responseCode === 200) {
            localStorage.setItem("userData", JSON.stringify(res.data.responseData));
            localStorage.setItem("isNew", "true");
            axios
              .post(window.ajaxLink + "user/login", {
                email: therapistData.email.trim(),
                password: therapistData.password.trim(),
                cloud: true,
              })
              .then((res) => {
                if (res.data.responseCode === 200) {
                  localStorage.setItem("userData", JSON.stringify(res.data.responseData));
                  props.checkLoggedIn(true);
                  setPtRegStep(3);
                }
              })
              .catch((error) => {
                console.error(error);
                if (error.response.data.errorData.emailErr) {
                  setErrorFirstName(error.response.data.errorData.emailErr);
                  setAllFilled(false);
                }
              });
          }
        })
        .catch((error) => {
          console.error(error);
          setAllFilled(false);
        });
    }
  };

  const checkAllErrors = () => {
    if (
      phone.length > 0 &&
      errorPhone.length === 0 &&
      !stateSelectedError &&
      address.length > 0 &&
      errorAddress.length === 0 &&
      !errorCity &&
      zipCode.length > 0 &&
      zipCodeError.length === 0 &&
      npiNumber.length > 0 &&
      npiError.length === 0 &&
      checkLicenceValid(licencedObj, "state", setErrorLicenceState, "Please select a state.") &&
      checkLicenceValid(licencedObj, "licence_date", setErrorLicenceDate, "Please select a date.")
    ) {
      setAllFilled(true);
    } else {
      setAllFilled(false);
    }
  };

  useEffect(() => {
    checkAllErrors();
    // eslint-disable-next-line
  }, [city, phone, stateSelected, address, city, zipCode, npiNumber, licencedObj]);

  return (
    <div className="memberRegisterHolder web_login_holder pt_reg_holder">
      {caliHeight > 0 && caliLeft > 0 && openCalendar && (
        <div
          ref={wrapperRef}
          className="calendar_contain"
          style={{
            position: "relative",
            top: caliHeight + "px",
            left: caliLeft + "px",
            display: setCaliHeight ? "block" : "none",
          }}
        >
          <Calendar
            onChange={handleLicenceDate}
            value={new Date(caliDate)}
            formatShortWeekday={(locale, date) => ["S", "M", "T", "W", "T", "F", "S"][date.getDay()]}
            calendarType={"US"}
            view={"month"}
            minDate={new Date()}
          />
        </div>
      )}
      <div className="pt_reg_title_large">Create Your Account</div>
      <div className="pt_reg_subtitle pt_reg_sub_expand">
        You have been invited to join your company Virdio Health account as a therapist.
      </div>

      <div style={{flex: 1, flexDirection: 'column', gap: '15px'}}>
      <div style={{flex: 1, display: 'flex', flexDirection: 'row', gap: '15px'}} className="pt_reg_fields pt_reg_fields_short">
        <div style={{flex: 1}}>
          <div className="pt_reg_inp_title">Name</div>
          <input
            className={"pt_reg_input_field pt_reg_inp_short" + (therapistData.first_name ? " pt_reg_disabled" : "")}
            value={therapistData.first_name ? therapistData.first_name : ""}
          />
        </div>
        <div  style={{flex: 1}}>
          <div className="pt_reg_inp_title"></div>
          <input
            className={"pt_reg_input_field pt_reg_inp_short" + (therapistData.last_name ? " pt_reg_disabled" : "")}
            value={therapistData.last_name ? therapistData.last_name : ""}
          />
        </div>
      </div>
      
      <div className="pt_add_err_hold">
        {(errorFirstName || errorLastName) && <div className="email_error_msg">{errorFirstName || errorLastName}</div>}
      </div>
      
      <div className="pt_reg_fields">
        <div className="pt_reg_inp_title">Email</div>
        <input
          className={"pt_reg_input_field" + (therapistData.email ? " pt_reg_disabled" : "")}
          value={therapistData.email ? therapistData.email : ""}
          disabled={therapistData && therapistData.email ? true : false}
        />
      </div>

      <div className="pt_reg_fields">
        <div className="pt_reg_inp_title">Phone</div>
        <input
          className={"pt_reg_input_field" + (errorPhone ? " err_inp_register" : "")}
          placeholder="e.g. 202-333-2222"
          value={phone}
          onChange={(e) => handlePhone(e.currentTarget.value)}
        />
        <div className="pt_add_err_hold">{errorPhone && <div className="email_error_msg">{errorPhone}</div>}</div>
      </div>
      <div className="pt_reg_fields">
        <div className="pt_reg_inp_title">Address</div>
        <input
          className={"pt_reg_input_field" + (errorAddress ? " err_inp_register" : "")}
          value={address}
          onChange={(e) => handleAddress(e.target.value)}
        />
        <div className="pt_add_err_hold">{errorAddress && <div className="email_error_msg">{errorAddress}</div>}</div>
      </div>
      <div className="pt_reg_fields">
        <div className="pt_reg_inp_title">Apt, suite, etc (Optional)</div>
        <input className="pt_reg_input_field" value={address2} onChange={(e) => handleAddress2(e.target.value)} />
      </div>
      <div className="pt_reg_fields">
        <div className="pt_reg_inp_title">Country</div>
        <div className="relative_holder reg_select_wrapper pt_reg_select_wrap">
          <div>
            <Select
              placeholder={"Select Country"}
              selectOptions={countryList}
              selectCallback={function (callVal, value) {
                setStateSelected("");
                setLicencedObj([{ state: "", licence_date: "" }]);
                callVal(value);
              }}
              initVal={"United States"}
              callBackValue={setCountrySelected}
            />
          </div>
        </div>
      </div>
      <div className="pt_reg_fields">
        <div className="pt_reg_inp_title">State</div>
        <div
          className={
            "relative_holder reg_select_wrapper pt_reg_select_wrap" +
            (!stateSelected && stateSelectedError ? " reg_select_error" : "")
          }
        >
          <div>
            <Select
              placeholder={"Select State"}
              initVal={stateSelected}
              selectOptions={countrySelected === "United States" ? unitedStateStateList : canadaStateList}
              selectCallback={function (callVal, value) {
                handleStateSelected(callVal, value);
              }}
              callBackValue={setStateSelected}
              selectError={!stateSelected && stateSelectedError}
            />
            {stateSelectedError && <div className="email_error_msg">{stateSelectedError}</div>}
          </div>
        </div>
      </div>
      <div className="pt_reg_fields">
        <div className="pt_reg_inp_title">City</div>
        <input
          className={"pt_reg_input_field" + (errorCity ? " err_inp_register" : "")}
          placeholder="Enter City"
          value={city}
          onChange={(e) => handleCity(e.target.value)}
        />
        <div className="pt_add_err_hold">{errorCity && <div className="email_error_msg">{errorCity}</div>}</div>
      </div>
      <div className="pt_reg_fields">
        <div className="pt_reg_inp_title">Zip Code</div>
        <input
          className={"pt_reg_input_field" + (zipCodeError ? " err_inp_register" : "")}
          onChange={(e) => handleZipCode(e.target.value)}
        />
        <div className="pt_add_err_hold">{zipCodeError && <div className="email_error_msg">{zipCodeError}</div>}</div>
      </div>

      <div className="pt_reg_inp_title">States you are licensed to practice in. (Select all that apply)</div>
      {licencedObj.map((item, i) => (
        <div className="pt_reg_fields pt_reg_fields_short pt_reg_fsh_licence">
          <div
            className={
              "relative_holder reg_select_wrapper pt_reg_select_wrap pt_reg_select_state" +
              (!item.state && errorLicenceState ? " reg_select_error" : "")
            }
          >
            <div>
              <Select
                placeholder={"Select State"}
                emptyErrorField={true}
                initVal={!item.state && errorLicenceState ? "" : item.state}
                selectOptions={countrySelected === "United States" ? unitedStateStateList : canadaStateList}
                selectCallback={handleLicenceState}
                callBackValue={i.toString()}
                selectError={!item.state && errorLicenceState}
              />
            </div>
            {i === licencedObj.length - 1 && errorLicenceState && (
              <div className="email_error_msg">{errorLicenceState}</div>
            )}
          </div>
          <div
            className={
              "relative_holder reg_select_wrapper pt_reg_select_wrap" +
              (!item.licence_date && errorLicenceDate ? " reg_select_error" : "")
            }
          >
            <div
              style={{ pointerEvents: !openCalendar ? "auto" : "none" }}
              onClick={(e) => openCloseLicenceDate(licencedObj.indexOf(item), e)}
            >
              <div>
                <Select
                  placeholder={"Expiry Date"}
                  initVal={item.licence_date}
                  selectOptions={[]}
                  selectError={!item.licence_date && errorLicenceDate}
                />
              </div>
            </div>
            {i === licencedObj.length - 1 && errorLicenceDate && (
              <div className="email_error_msg">{errorLicenceDate}</div>
            )}
          </div>
          <div
            className={"pt_reg_licence_delete" + (i === 0 ? " pt_reg_licence_no_back" : "")}
            onClick={() => (i > 0 ? deleteLicence(i) : "")}
          ></div>
        </div>
      ))}

      <div className="pt_add_licence" onClick={() => addNewLicence()}>
        <div className="pt_add_licence_icon"></div>
        <div className="pt_add_licence_text">Add another state</div>
      </div>

      <div className="pt_reg_fields">
        <div className="pt_reg_inp_title">NPI Number</div>
        <input
          className={"pt_reg_input_field" + (npiError ? " err_inp_register" : "")}
          onChange={(e) => handleNpi(e.target.value)}
        />
        <div className="pt_add_err_hold">{npiError && <div className="email_error_msg">{npiError}</div>}</div>
      </div>

      <div
        className={"next_btn_questionare pt_reg_next_adj" + (!isAllFilled ? " quest_procc_disabled" : "")}
        onClick={() => checkValidity()}
      >
        Continue
      </div>
      </div>


    </div>
  );
};

export default TherapistRegisterData;
